import { useEffect } from 'react';

/**
 * 탭 전환 시 Supabase API 호출을 줄이는 Hook
 */
export const useReduceTabRefresh = () => {
  useEffect(() => {
    let lastRefreshTime = Date.now();
    const MIN_REFRESH_INTERVAL = 30000; // 30초

    // 페이지 가시성 변경 이벤트 처리
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        const now = Date.now();
        const timeSinceLastRefresh = now - lastRefreshTime;
        
        // 마지막 새로고침으로부터 30초 이내면 이벤트 무시
        if (timeSinceLastRefresh < MIN_REFRESH_INTERVAL) {
          // 이벤트 전파 중지
          const event = new Event('visibilitychange');
          event.stopImmediatePropagation();
        } else {
          lastRefreshTime = now;
        }
      }
    };

    // visibilitychange 이벤트 리스너를 가장 먼저 등록
    document.addEventListener('visibilitychange', handleVisibilityChange, true);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange, true);
    };
  }, []);
};
